import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';

import { useAuth } from '../hooks/use-auth';

interface Props {
  feature: string;
  children: ReactNode;
  redirectTo?: string;
}

export const RequirePermission = ({
  feature,
  children,
  redirectTo = '/',
}: Props) => {
  const { hasPermission } = useAuth();
  if (!hasPermission(feature)) {
    return <Navigate to={redirectTo} replace />;
  }
  return <>{children}</>;
};
